import { EmployeeDTO } from 'probonio-shared-ui/api';
import i18n from '../../lang';

export function renderUserName(
  employee?: Pick<EmployeeDTO, 'firstName' | 'lastName' | 'mail'>,
  employeeNumber?: string,
  isInactive?: boolean,
): string {
  const hasFullName = !!employee?.firstName && !!employee?.lastName;

  let displayName = i18n.t('common:anonymousEmployee');

  if (hasFullName) {
    displayName = `${employee!.firstName} ${employee!.lastName}`;
  } else if (employee?.mail) {
    displayName = employee.mail;
  } else if (employeeNumber) {
    displayName = i18n.t('common:anonymousEmployeeWithNumber', { employeeNumber });
  }

  return `${displayName}${isInactive ? ` (${i18n.t('usersModule:statusTerminated')})` : ''}`;
}
